<template>
    <path style="fill:#281F1F;" d="M71,37.6c-1-0.4-1.4-1.1-4.2-1.8c-2.7-0.7-5.9-0.6-8-0.3s-2.6,0.7-3.3,0.7c-0.8,0-1.5,0-1.5,0
	s-0.8,0-1.5,0c-0.8,0-1.3-0.4-3.3-0.7s-5.2-0.4-8,0.3c-2.7,0.7-3.2,1.4-4.2,1.8c-1,0.4-2.6,1.3-2.6,1.3l0.1,1l3-0.7
	c0.2,1.3,0.3,3.7,2.4,6.3c2.1,2.6,9.2,2.4,11-0.5c1.9-2.9,1.3-6.4,1.7-6.9s1.5-0.5,1.5-0.5s1.1,0,1.5,0.5s-0.2,4,1.7,6.9
	c1.9,2.9,8.9,3.1,11,0.5c2.1-2.6,2.2-5.1,2.4-6.3l3,0.7l0.1-1C73.7,39,72.1,38.1,71,37.6z M50.9,40.5c-0.1,1.7-0.4,3.2-1.3,4.2
	c-0.9,1-2,1.3-3.9,1.5c-2,0.2-3.5-0.1-4.8-1.4c-1.3-1.2-2.2-3.9-2-5.4c0.2-1.4,3.4-2.4,6.1-2.4c2.7,0,4.9,0.4,5.4,1
	C51,38.5,51,38.8,50.9,40.5z M67,44.7c-1.3,1.2-2.8,1.6-4.8,1.4c-1.8-0.2-2.9-0.5-3.9-1.5c-0.9-1-1.3-2.5-1.3-4.2
	c-0.1-1.7-0.1-2,0.5-2.6c0.6-0.6,2.8-1,5.4-1c2.7,0,5.8,1,6.1,2.4C69.2,40.8,68.3,43.5,67,44.7z"/>
</template>

<script>
    export default {
        name: 'Eye2',
    }
</script>
